import { getDefaultUserName } from "../../../../constants/defaultUsers";
import { useResourceInfo } from "../../../../hooks/useResourceInfo";
import { ResourceAvatarCounter, WorkUnitResourceAvtar } from "./WorkUnitResourceAvtar";
interface ResourcesProps {
  resources: string[];
  projectId: string;
}



export const WorkUnitResourceMembers = ({ resources = [], projectId = '' }: ResourcesProps) => {
    const { resourcesLoading, getResourceInfo } = useResourceInfo();

    if (resources.length === 0) return null;

    const projectResources = resources.map(resourceId => {
        const creatorName = getDefaultUserName(resourceId);

        if (resourceId && !creatorName)
            return { ...getResourceInfo(resourceId), resourceId };

        return {
            name: creatorName,
            image_url: "https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/cadencelogo.webp",
            resourceId
        };
    });

    const firstResource = projectResources[0];
    const secondResource = projectResources[1];

    if (!resourcesLoading && (!projectResources || !projectResources.length)) {
        return <></>;
    }

    return (
      <div className="whitespace-nowrap font-medium  w-full items-center">
        {projectResources.length > 0 && (
          <div className="flex items-center -space-x-2 h-full">
            <WorkUnitResourceAvtar
              name={firstResource?.name}
              imageUrl={firstResource?.image_url}
              resourceId={firstResource?.resourceId}
              className="relative"
            />
            {secondResource && (
              <WorkUnitResourceAvtar
                name={secondResource?.name}
                imageUrl={secondResource?.image_url}
                resourceId={secondResource?.resourceId}
                className="relative -ml-2"
              />
            )}
            {projectResources.length > 2 && (
              <ResourceAvatarCounter
                count={projectResources.length - 2}
                remainingNames={
                  projectResources
                    .slice(2)
                    .map((r) => r?.name)
                    .filter(Boolean) as string[]
                }
                className="relative -ml-2"
              />
            )}
          </div>
        )}
      </div>
    );
};


